import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=060801e6&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=060801e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060801e6",
  null
  
)

export default component.exports